import PermissionUser from '@/inheritance/permission-user';

export default {
    extends: PermissionUser,
    methods: {
        /**
         * Guardamos la información del formulario en el estado global
         * @param {Object} property Propiedad del componente a la que pertenecen los nuevos valores
         * @param {Object} newData Nuevos valores
         */
        watchHandler(property, newData) {
            if (!this.loading) {
                const storedFormProperties = this.$store.getters['formStore/properties'](`${this.$route.path}__${this.$options.name}`);
                this.$store.dispatch('formStore/upsertForm', {
                    id: `${this.$route.path}__${this.$options.name}`,
                    properties: { ...storedFormProperties, [property]: newData }
                });
            }
        },
        getStoredComponentData() {
            return this.$store.getters['formStore/properties'](`${this.$route.path}__${this.$options.name}`);
        },
        deleteStoredComponentData() {
            this.$store.dispatch('formStore/deleteForm', `${this.$route.path}__${this.$options.name}`);
        }
    },
    mounted() {
        if (!this.formWatcherProperties || !this.formWatcherProperties.length) {
            console.warn(`Form watcher used without formWatcherProperties in ${this.$options.name} component`);
            return;
        }
        this.formWatcherProperties.forEach(property =>
            this.$watch(property, newData => this.watchHandler(property, newData), { immediate: true, deep: true })
        );
    }
};
